import React from 'react';
import './footer.css';
const Footer = () => {
	return <div className="footer">Copyright © Matthew Hirai, 2022</div>;
};

export default Footer;
